import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    wrapper: 'flex flex-col gap-2',
    base: 'flex justify-between gap-5 max-sm:flex-col sm:gap-10',
    main: 'w-full sm:max-w-100',
    quantity: 'max-w-45',
    quantityTitle: 'heading-s mb-2',
    chips: 'flex flex-wrap gap-2',
    price: 'mt-5',
    priceInput: 'w-full',
    errorMessage: 'heading-s text-error'
  }
});
